/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
  name: 'UiFormAddressSummary',

  // language=HTML (for PhpStorm)
  template: `
    <ui-form-item>
      {{ address.street }} <br>
      <template v-if="address.street2">
        {{ address.street2 }} <br>
      </template>
      {{ address.city }}, {{ address.state }} {{ address.zip }}
    </ui-form-item>
  `,

  props: {
    address: {
      type: Object,
      required: true,
      default() {
        return {
          street: null,
          street2: null,
          city: null,
          state: null,
          zip: null,
        }
      },
    },
  },
}

